/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useContext, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { withStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import orderBy from 'lodash/orderBy';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { uniqueId } from 'lodash';

// icon
import { RainIcon } from '../../assets/svg/Icon';

// components
import Map from './map/Map';
import RainfallLegend from './legend/RainfallLegend';
import RainfallLegend3day from './legend/RainfallLegend3day';
import RainfallLegend7day from './legend/RainfallLegend7day';
import RainfallLegendMonth from './legend/RainfallLegendMonth';
import RainfallLegendYear from './legend/RainfallLegendYear';
import Rainfall24hList from './lists/latest/Rainfall24hList';
import RainTodayList from './lists/latest/RainTodayList';
import RainYesterdayList from './lists/latest/RainYesterdayList';
import RainfallMonthList from './lists/latest/RainfallMonthList';
import RainfallYearList from './lists/latest/RainfallYearList';
import Rainfall3DayList from './lists/latest/Rainfall3DayList';
import Rainfall7DayList from './lists/latest/Rainfall7DayList';
import ImageRainfallisohyet from './listImageRainfall/imageRainfallisohyet';

import ModeContext from '../../context/ModeContext';
import UserContext from '../../context/UserContext';

// style
import './styles.css';
import { globalStyle } from '../../global/style';
import style from './lists/style';
import {
  StyledViewButton,
} from '../../components/button/Button';

const useStyles = makeStyles(globalStyle);
const useStylesTab = makeStyles(style);
const CustomTooltip = withStyles(() => ({
  tooltip: {
    fontSize: 14,
  },
}))(Tooltip);

function TabPanel(props) {
  const {
    children, value, index,
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `rainfall-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Main(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const classesTab = useStylesTab();
  const [error, setError] = useState('');
  const [dataRainfall24, setDataRainfall24] = useState([]);
  const [datasRainToday, setDataRainToday] = useState([]);
  const [datasRainYesterday, setDataRainYesterday] = useState([]);
  const [datasRainMonth, setDatasRainMonth] = useState([]);
  const [datasRainYear, setDataRainYear] = useState([]);
  const [datasRain3day, setDatasRain3day] = useState([]);
  const [datasRain7day, setDatasRain7day] = useState([]);
  const [map, setMap] = useState(null);
  const [markers] = useState([]);
  const [value, setValue] = useState(0);
  const [valueTab2, setValueTab2] = useState(0);
  const [valueTab3, setValueTab3] = useState(0);
  const [type, setType] = useState('rainfall24h');
  const [typeAll, setTypeAll] = useState(0);
  const { currentMode, currentArea } = useContext(ModeContext);
  const { userIsLogin } = useContext(UserContext);
  const { history } = props;

  function handleData() {
    setType('rainfall24h');
  }

  function handleDataRainTaday() {
    setType('rainfallToday');
  }

  function handleDataRainfallYesterday() {
    setType('rainfallYesterday');
  }

  function handleDataRainfallMonth() {
    setType('rainfallMonth');
  }

  function handleDataRainfallYear() {
    setType('rainfallYear');
  }

  function handleDataRainfall3day() {
    setType('rainfall3day');
  }

  function handleDataRainfall7day() {
    setType('rainfall7day');
  }
  // get map reference and set to state
  const handleSetMap = (mapRef) => {
    setMap(mapRef);
  };

  // link table to marker
  const handleSearchMarker = (id, lat, lng) => (e) => {
    // prevent default action
    e.preventDefault();

    // pan map to current marker position
    map.panTo([parseFloat(lat), parseFloat(lng)]);

    // open Popup
    const currentMarker = markers[id];
    if (currentMarker) {
      currentMarker.openPopup();
    }
  };

  const handleChange = (event, newValue) => {
    if (newValue === 0) setType('rainfall24h');
    if (newValue === 1) setType('rainfallToday');
    if (newValue === 2) setType('rainfallYesterday');
    if (newValue === 3) setType('rainfall3day');
    if (newValue === 4) setType('rainfall7day');

    setValue(newValue);
    // setModalData(modalDataReset);
  };

  const handleChangeTab2 = (event, newValue) => {
    if (newValue === 0) setType('rainfallMonth');
    if (newValue === 1) setType('rainfallYear');

    setValueTab2(newValue);
    // setModalData(modalDataReset);
  };

  const handleChangeTab3 = (event, newValue) => {
    setValueTab3(newValue);
  };

  function handleChangeTypeAll0() {
    if (value === 0) setType('rainfall24h');
    if (value === 1) setType('rainfallToday');
    if (value === 2) setType('rainfallYesterday');
    if (value === 3) setType('rainfall3day');
    if (value === 4) setType('rainfall7day');

    setTypeAll(0);
    // setModalData(modalDataReset);
  }

  function handleChangeTypeAll1() {
    if (valueTab2 === 0) setType('rainfallMonth');
    if (valueTab2 === 1) setType('rainfallYear');

    setTypeAll(1);
    // setModalData(modalDataReset);
  }

  useEffect(() => {
    const fetchData = async () => {
      fetch(`${process.env.REACT_APP_API_URL}/public/rain_24h`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          const currentDateTime = new Date();
          const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 2);

          const rainfall24Sort = orderBy(result.data, ['rain_24h'], ['desc']);
          const dataRainfall24h = rainfall24Sort.filter((d) => {
            const time = new Date(d.rainfall_datetime.replace(/-/g, '/')).getTime();
            return (last24hrs < time && d.rain_24h > 0);
          });

          // set data state
          setDataRainfall24(dataRainfall24h);
        })
        .catch((err) => setError(err));
    };
    // get data from service rain today
    fetch(`${process.env.REACT_APP_API_URL}/public/rain_today`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        const currentDateTime = new Date();
        const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 2);

        const rainTodaySort = orderBy(result.data, ['rainfall_value'], ['desc']);
        const filterDatas = rainTodaySort.filter((d) => {
          const time = new Date(d.rainfall_datetime.replace(/-/g, '/')).getTime();
          return (last24hrs < time && d.rainfall_value > 0);
        });
        setDataRainToday(filterDatas);
      })
      .catch((err) => setError(err));

    // get data from service rain yesterday
    fetch(`${process.env.REACT_APP_API_URL}/public/rain_yesterday`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        // filter null and data not updated in 24 hrs
        const currentDateTime = new Date();
        const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 2);

        // sorting and filter, rainToday
        const rainTodaySort = orderBy(result.data, ['rainfall_value'], ['desc']);
        const filterDatas = rainTodaySort.filter((d) => {
          const time = new Date(d.rainfall_datetime.replace(/-/g, '/')).getTime();
          return (last24hrs < time && d.rainfall_value > 0);
        });
        setDataRainYesterday(filterDatas);
      })
      .catch((err) => setError(err));

    // get data from service rain month
    fetch(`${process.env.REACT_APP_API_URL}/public/rain_monthly`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        // filter null and data not updated in 24 hrs
        const currentDateTime = new Date();
        const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 60);

        // sorting and filter, rainToday
        const rainTodaySort = orderBy(result.data, ['rainfall_value'], ['desc']);
        const filterDatas = rainTodaySort.filter((d) => {
          const time = new Date(d.rainfall_datetime.replace(/-/g, '/')).getTime();
          return (last24hrs < time && d.rainfall_value > 0);
        });
        setDatasRainMonth(filterDatas);
      })
      .catch((err) => setError(err));

    // get data from service rain year
    fetch(`${process.env.REACT_APP_API_URL}/public/rain_yearly`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        // sorting and filter, rainToday
        const rainYearlySort = orderBy(result.data, ['rainfall_value'], ['desc']);
        const filterDatas = rainYearlySort.filter((d) => {
          const rainfallValue = d.rainfall_value;
          return (rainfallValue > 0);
        });
        setDataRainYear(filterDatas);
      })
      .catch((err) => setError(err));

    // get data from service rain year
    fetch(`${process.env.REACT_APP_API_URL}/provinces/rain3d`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        // sorting and filter, rainToday
        const rainTodaySort = orderBy(result.data, ['rain_3d'], ['desc']);
        const filterDatas = rainTodaySort.filter((d) => {
          const rainfallValue = d.rain_3d;
          return (rainfallValue > 0);
        });
        setDatasRain3day(filterDatas);
      })
      .catch((err) => setError(err));

    // get data from service rain year
    fetch(`${process.env.REACT_APP_API_URL}/provinces/rain7d`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        // sorting and filter, rainToday
        // const rain7dSort = orderBy(result.data, ['rain_7d'], ['desc']);
        // Fix sorting, data sent number as text
        const rain7dSort = result.data.slice().sort((a, b) => parseFloat(a) - parseFloat(b));
        const filterDatas = rain7dSort.filter((d) => {
          const rainfallValue = d.rain_7d;
          return (rainfallValue > 0);
        });
        setDatasRain7day(filterDatas);
      })
      .catch((err) => setError(err));

    fetchData();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('typeAll')) {
      if (queryParams.get('typeAll') === '1') {
        setTypeAll(1);
      } else {
        setTypeAll(0);
      }
    }
  }, []);

  useLayoutEffect(() => {
    localStorage.removeItem('currentDate');
    return () => {
      localStorage.removeItem('currentDate');
    };
  }, []);

  return (
    <div className={classes.root}>
      {error && <div>Error Occured</div>}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={4}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <RainIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('ฝน')}</Typography></Box>
          </Box>
          {((typeAll === 0) || (typeAll === 1)) && (
            <Box>
              <Map
                markers={markers}
                dataRainfall24={dataRainfall24}
                datasRainToday={datasRainToday}
                datasRainYesterday={datasRainYesterday}
                datasRainMonth={datasRainMonth}
                datasRainYear={datasRainYear}
                datasRain3day={datasRain3day}
                datasRain7day={datasRain7day}
                handleSetMap={handleSetMap}
                type={type}
                // handleModalOpen={handleModalOpen}
                currentMode={currentMode}
                currentArea={currentArea}
              />
              {(type === 'rainfall3day') && (
                <RainfallLegend3day />
              )}
              {(type === 'rainfall7day') && (
                <RainfallLegend7day />
              )}
              {(type === 'rainfallMonth') && (
                <RainfallLegendMonth />
              )}
              {(type === 'rainfallYear') && (
                <RainfallLegendYear />
              )}
              {(type === 'rainfall24h' || type === 'rainfallToday' || type === 'rainfallYesterday') && (
                <RainfallLegend />
              )}
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <Box mt={{ xs: 0, sm: 0, md: 2 }}>
            <Grid container direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
              <Grid item xs md="auto">
                {userIsLogin && (
                  <Link
                    href={`${process.env.REACT_APP_TIWRM_URL}/DATA/REPORT/php/radar/show_NHCRainContour.php`}
                    target="_blank"
                    title="Contour Images of Rain Accumulation"
                  >
                    <Typography style={{ fontsize: 16, fontFamily: 'Kanit' }}>Contour Images of Rain Accumulation</Typography>
                  </Link>
                )}
              </Grid>
              <Grid item xs md={2}>
                <FormControl className={classes.formControl}>
                  <StyledViewButton id="rain-menu-btn" onClick={handleChangeTypeAll0} variant="outlined" size="small" className={typeAll === 0 ? classes.active_btnStyle : classes.btnStyle}>
                    {t('ฝนสะสม')}
                  </StyledViewButton>
                </FormControl>
              </Grid>
              <Grid item xs md={2}>
                <FormControl className={classes.formControl}>
                  <StyledViewButton id="rain-stat-menu-btn" onClick={handleChangeTypeAll1} variant="outlined" size="small" className={typeAll === 1 ? classes.active_btnStyle : classes.btnStyle}>
                    {t('ฝนสถิติ')}
                  </StyledViewButton>
                </FormControl>
              </Grid>
              <Grid item xs md={2}>
                <FormControl className={classes.formControl}>
                  <StyledViewButton id="rain-stat-menu-btn" onClick={() => history.push('rainfall/isohyet')} variant="outlined" size="small" className={typeAll === 2 ? classes.active_btnStyle : classes.btnStyle}>
                    {t('ภาพ isohyet')}
                  </StyledViewButton>
                </FormControl>
              </Grid>
            </Grid>
            {(typeAll === 0) && (
              <Box mt={3}>
                <Tabs value={value} onChange={handleChange} indicatorColor="primary" variant="scrollable" scrollButtons="auto">
                  <CustomTooltip title={t('ปริมาณฝนสะสมตั้งแต่เวลาปัจจุบันย้อนหลังไป 24 ชั่วโมง')}>
                    <Tab label={t('ฝน 24 ชั่วโมง')} {...a11yProps(0)} className={value === 0 ? classesTab.active_tab : classesTab.tab} />
                  </CustomTooltip>
                  <CustomTooltip title={t('ปริมาณฝนสะสมตั้งแต่เวลา 7.00 น. ของวันนี้ จนถึงเวลาปัจจุบันของวันนี้')}>
                    <Tab label={t('ฝนวันนี้')} {...a11yProps(1)} className={value === 1 ? classesTab.active_tab : classesTab.tab} />
                  </CustomTooltip>
                  <CustomTooltip title={t('ปริมาณฝนสะสมที่เกิดขึ้นตั้งแต่ 7.00 น. ของวันก่อนหน้าถึง 7.00 น. ของวันปัจจุบัน')}>
                    <Tab label={t('ฝนวานนี้')} {...a11yProps(2)} className={value === 2 ? classesTab.active_tab : classesTab.tab} />
                  </CustomTooltip>
                  <CustomTooltip title={t('ผลรวมของฝนรายวันจำนวน 3 วัน')}>
                    <Tab label={t('ฝน 3 วัน')} {...a11yProps(3)} className={value === 3 ? classesTab.active_tab : classesTab.tab} />
                  </CustomTooltip>
                  <CustomTooltip title={t('ผลรวมของฝนรายวันจำนวน 7 วัน')}>
                    <Tab label={t('ฝน 7 วัน')} {...a11yProps(4)} className={value === 4 ? classesTab.active_tab : classesTab.tab} />
                  </CustomTooltip>
                </Tabs>
                <TabContainer component="div">
                  <TabPanel value={value} index={0}>
                    <Rainfall24hList
                      datas={dataRainfall24}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleData}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
                <TabContainer component="div">
                  <TabPanel value={value} index={1}>
                    <RainTodayList
                      datas={datasRainToday}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleDataRainTaday}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
                <TabContainer component="div">
                  <TabPanel value={value} index={2}>
                    <RainYesterdayList
                      datas={datasRainYesterday}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleDataRainfallYesterday}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
                <TabContainer component="div">
                  <TabPanel value={value} index={3}>
                    <Rainfall3DayList
                      datas={datasRain3day}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleDataRainfall3day}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
                <TabContainer component="div">
                  <TabPanel value={value} index={4}>
                    <Rainfall7DayList
                      datas={datasRain7day}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleDataRainfall7day}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
              </Box>
            )}
            {(typeAll === 1) && (
              <Box mt={3}>
                <Tabs value={valueTab2} onChange={handleChangeTab2} indicatorColor="primary" scrollButtons="auto">
                  <Tab label={t('ฝนรายเดือน')} {...a11yProps(0)} className={valueTab2 === 0 ? classesTab.active_tab : classesTab.tab} />
                  <Tab label={t('ฝนรายปี')} {...a11yProps(1)} className={valueTab2 === 1 ? classesTab.active_tab : classesTab.tab} style={{ border: '1px solid #ccc' }} />
                </Tabs>
                <TabContainer component="div">
                  <TabPanel value={valueTab2} index={0}>
                    <RainfallMonthList
                      datas={datasRainMonth}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleDataRainfallMonth}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
                <TabContainer component="div">
                  <TabPanel value={valueTab2} index={1}>
                    <RainfallYearList
                      datas={datasRainYear}
                      handleSearchMarker={handleSearchMarker}
                      handleData={handleDataRainfallYear}
                      currentMode={currentMode}
                      currentArea={currentArea}
                      userIsLogin={userIsLogin}
                    />
                  </TabPanel>
                </TabContainer>
              </Box>
            )}
          </Box>
        </Grid>
        {(typeAll === 2) && (
          <Grid item xs={12} sm={12} md={8} lg={12} key={uniqueId()}>
            <Box mt={1}>
              <Tabs value={valueTab3} onChange={handleChangeTab3} indicatorColor="primary" variant="scrollable" scrollButtons="auto" key={uniqueId()} style={{ borderBottom: '1px solid #ccc' }}>
                <Tab label={t('ภาพ isohyet')} className={valueTab3 === 0 ? classesTab.active_tab : classesTab.tab} key={uniqueId()} />
              </Tabs>
              <TabContainer component="div" key={uniqueId()}>
                <TabPanel value={valueTab3} index={0} key={uniqueId()}>
                  <ImageRainfallisohyet status="lasted" />
                </TabPanel>
              </TabContainer>
            </Box>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

TabPanel.defaultProps = {
  children: '',
};

Main.propTypes = {
  history: PropTypes.any.isRequired,
}